// App info
import React from 'react';
import { AppJs } from '@westernmilling/react_component_library';

import OttoUpdateListContainer from 'containers/OttoUpdateListContainer';
import OttoUpdateViewContainer from 'containers/OttoUpdateViewContainer';

import './react_info.css';

export default class App extends AppJs {
  defaultRoute = () => OttoUpdateListContainer;

  getImage = () => `/info${process.env.REACT_APP_URL_ENV}/images/otto_logo.gif`;

  underNav = () => (
    <div>
      <img src={this.getImage()} width="100%" alt="otto logo" />
      <br />
    </div>
  );

  routes = () => [
    { path: '/otto_updates/view/:uuid', component: OttoUpdateViewContainer },
    { path: '/otto_updates', component: OttoUpdateListContainer },
  ];
}
